module.exports = __webpack_public_path__ + "img/322578132462c02f5e766748a8c6f22f.svg";